import {
  Button,
  Card,
  Container,
  createStyles,
  LoadingOverlay,
  MediaQuery,
  Paper,
  Text,
} from "@mantine/core";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Toast from "./../Toast";
import { DownloadIcon } from "@modulz/radix-icons";
import { fetchContactCardsApi } from "../../api/dashboard";

const useStyles = createStyles((theme) => ({
  card: {
    position: "relative",
    overflow: "hidden",
    padding: theme.spacing.xl,
    width: "100%",

    backgroundColor:
      theme.colorScheme === "dark"
        ? theme.colors.dark[6]
        : theme.colors.gray[0],
  },
  headBar: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    alignItems: "center",
    textAlign: "center",
    backgroundColor:
      theme.colorScheme === "dark"
        ? theme.colors.dark[6]
        : theme.colors.gray[0],
  },
  domainCard: {
    position: "relative",
    cursor: "pointer",
    overflow: "hidden",
    transition: "transform 150ms ease, box-shadow 100ms ease",
    padding: theme.spacing.md,
    paddingLeft: theme.spacing.md * 2,

    "&:hover": {
      boxShadow: theme.shadows.md,
      transform: "scale(1.02)",
    },

    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      width: 6,
      backgroundImage: theme.fn.linearGradient(
        0,
        "#00FFF0",
        "#3391FF",
        "#0063F8"
      ),
    },
  },
  button: {
    margin: 5,
  },
  buttonDiv: {
    display: "flex",
    justifyContent: "space-between",
  },
  backWa: {
    backgroundColor:
      theme.colorScheme === "dark"
        ? theme.colors.dark[6]
        : theme.colors.gray[0],
  },
}));

async function fetchContactCards() {
  const res = await fetchContactCardsApi().catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      localStorage.clear();
      window.location.replace("/");
    }
  });
  if (res == null) return [];
  if (res.status == 200) {
    return res.data;
  } else {
    Toast("ERROR", res.data.message, "red");
    return [];
  }
}

function downloadFile(name, contents, mimeType) {
  mimeType = mimeType || "text/plain";

  let blob = new Blob([contents], { type: mimeType });

  let dlink = document.createElement("a");
  dlink.download = name;
  dlink.href = window.URL.createObjectURL(blob);
  dlink.onclick = function () {
    let that = this;
    setTimeout(function () {
      window.URL.revokeObjectURL(that.href);
    }, 1500);
  };
  dlink.click();
  dlink.remove();
}

function ContactCard(props) {
  const { classes, theme } = useStyles();
  return (
    <>
      <Paper
        radius="md"
        className={classes.domainCard}
        style={{
          marginBottom: 10,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Text
          size="md"
          weight={500}
          style={{
            display: "flex",
            alignItems: "left",
            fontSize: theme.fontSizes.lg,
          }}
        >
          {props.domain}
        </Text>
        <Paper className={classes.buttonDiv}>
          <Button
            className={classes.button}
            style={{
              fontWeight: "normal",
            }}
            onClick={() => {
              downloadFile(
                `${props.domain.toUpperCase()} Contact Cards`,
                props.vcfCard,
                "text/vcard"
              );
            }}
          >
            <DownloadIcon />
          </Button>
        </Paper>
      </Paper>
    </>
  );
}

ContactCard.propTypes = {
  domain: PropTypes.string,
  vcfCard: PropTypes.any,
};

export function ContactCards() {
  const { classes, theme } = useStyles();
  const [res, setres] = useState([]);
  const [dataLoad, setdataLoad] = useState(true);
  useEffect(() => {
    fetchContactCards().then((res) => {
      setres(res);
      setdataLoad(false);
    });
  }, []);
  if (dataLoad == true) {
    return (
      <Container
        style={{
          maxwidth: "100%",
          paddingLeft: "0px",
          paddingRight: "0px",
          marginTop: 30,
        }}
      >
        <Paper className={classes.card}>
          <Paper className={classes.headBar}>
            <Card>
              <LoadingOverlay visible={dataLoad} />
            </Card>
          </Paper>
        </Paper>
      </Container>
    );
  }
  if (res.length == 0) return null;
  return (
    <Container
      style={{
        maxwidth: "100%",
        paddingLeft: "0px",
        paddingRight: "0px",
        marginTop: 30,
      }}
    >
      <Paper className={classes.card}>
        <MediaQuery largerThan="sm" styles={{ fontSize: 30 }}>
          <MediaQuery smallerThan="sm" styles={{ fontSize: 20 }}>
            <Paper className={classes.headBar}>Contact Cards</Paper>
          </MediaQuery>
        </MediaQuery>
        <Paper
          style={{
            backgroundColor:
              theme.colorScheme === "dark"
                ? theme.colors.dark[6]
                : theme.colors.gray[0],
          }}
        >
          {res.map((domaincard) => {
            return (
              <ContactCard
                key={domaincard.domain}
                domain={domaincard.domain}
                vcfCard={domaincard.vcfCard}
              />
            );
          })}
        </Paper>
      </Paper>
    </Container>
  );
}
